export const knowledgebaseUrl = '/helpdesk/knowledgebase';
export const documentationUrl = '/helpdesk/documentation';
export const templatesUrl = '/helpdesk/templates';
export const releaseNotes = '/helpdesk/documentation/release-notes';
export const apiUrl = '/helpdesk/documentation/stape-api';
export const apiDocUrl = process.env.NEXT_PUBLIC_API_DOC_URL ?? '#';
export const blogUrl = process.env.NEXT_PUBLIC_BLOG_URL ?? '#';
export const communityUrl = process.env.NEXT_PUBLIC_COMMUNITY_URL ?? '#';
export const contactContactSupportUrl = process.env.NEXT_PUBLIC_CONTACT_SUPPORT_URL ?? '#';
export const featureUrl = process.env.NEXT_PUBLIC_FEATURE_URL ?? '#';
export const stapeLogin = process.env.NEXT_PUBLIC_STAPE_LOGIN ?? '#';
export const stapeURL = process.env.NEXT_PUBLIC_STAPE ?? '#';
